<template>
  <svg
    width="96"
    height="99"
    viewBox="0 0 96 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_13359_5794)">
      <path
        d="M79.3348 10.3447V88.6553C79.3348 94.3594 74.8406 99 69.3172 99H26.6313C21.1078 99 16.6138 94.3594 16.6138 88.6553V10.3447C16.6136 4.64062 21.1078 0 26.6313 0H69.3172C74.8406 0 79.3348 4.64062 79.3348 10.3447Z"
        fill="#56788B"
      />
      <path
        d="M79.3348 10.3447V88.6553C79.3348 94.3594 74.8406 99 69.3172 99H65.5674C71.0908 99 75.5849 94.3594 75.5849 88.6553V10.3447C75.5849 4.64062 71.0908 0 65.5674 0H69.3172C74.8406 0 79.3348 4.64062 79.3348 10.3447Z"
        fill="#415E6F"
      />
      <path
        d="M73.7177 10.105V88.895C73.7177 91.428 71.7229 93.4893 69.2685 93.4893H26.6801C24.226 93.4893 22.231 91.428 22.231 88.895V10.105C22.231 7.57195 24.2258 5.51074 26.6801 5.51074H31.1256C31.735 5.51074 32.2768 5.9168 32.4643 6.51621L33.565 10.0412C33.8387 10.9171 34.6187 11.5049 35.5091 11.5049H60.4397C61.3285 11.5049 62.1103 10.9171 62.3841 10.0412L63.4847 6.51621C63.6722 5.9168 64.2122 5.51074 64.8235 5.51074H69.2689C71.7227 5.51074 73.7177 7.57195 73.7177 10.105Z"
        fill="#D9F0F4"
      />
      <path
        d="M73.7176 10.105V88.895C73.7176 91.428 71.7227 93.4893 69.2684 93.4893H65.5186C67.9727 93.4893 69.9677 91.428 69.9677 88.895V10.105C69.9677 7.57195 67.9729 5.51074 65.5186 5.51074H69.2684C71.7226 5.51074 73.7176 7.57195 73.7176 10.105Z"
        fill="#BAE1E5"
      />
      <path
        d="M55.589 4.25098H40.3589C39.5823 4.25098 38.9526 4.90028 38.9526 5.70117C38.9526 6.50207 39.5823 7.15137 40.3589 7.15137H55.589C56.3656 7.15137 56.9952 6.50207 56.9952 5.70117C56.9952 4.90028 56.3656 4.25098 55.589 4.25098Z"
        fill="#415E6F"
      />
      <path
        d="M55.589 84.0576H40.3589C39.5823 84.0576 38.9526 84.7069 38.9526 85.5078C38.9526 86.3087 39.5823 86.958 40.3589 86.958H55.589C56.3656 86.958 56.9952 86.3087 56.9952 85.5078C56.9952 84.7069 56.3656 84.0576 55.589 84.0576Z"
        fill="#56788B"
      />
      <path
        d="M32.2014 23.3385V37.9604C32.2014 40.4044 30.2741 42.3941 27.906 42.3941H9.67069L2.25731 48.2103C2.00794 48.4076 1.70794 48.5062 1.40606 48.5062C1.19231 48.5062 0.978563 48.4578 0.781688 48.3554C0.30375 48.1117 0 47.607 0 47.056V23.3385C0 20.8945 1.9275 18.9048 4.29544 18.9048H27.9062C30.2741 18.9048 32.2014 20.8945 32.2014 23.3385Z"
        fill="#4DD4F7"
      />
      <path
        d="M32.2015 23.3385V37.9604C32.2015 40.4044 30.2742 42.3941 27.9061 42.3941H24.1562C26.5242 42.3941 28.4517 40.4044 28.4517 37.9604V23.3385C28.4517 20.8945 26.5244 18.9048 24.1562 18.9048H27.9061C30.2742 18.9048 32.2015 20.8945 32.2015 23.3385Z"
        fill="#00C2F3"
      />
      <path
        d="M23.5892 25.8027H8.6123C7.83568 25.8027 7.20605 26.452 7.20605 27.2529C7.20605 28.0538 7.83568 28.7031 8.6123 28.7031H23.5892C24.3659 28.7031 24.9955 28.0538 24.9955 27.2529C24.9955 26.452 24.3659 25.8027 23.5892 25.8027Z"
        fill="white"
      />
      <path
        d="M21.7172 32.377H8.6123C7.83568 32.377 7.20605 33.0263 7.20605 33.8271C7.20605 34.628 7.83568 35.2773 8.6123 35.2773H21.7172C22.4939 35.2773 23.1235 34.628 23.1235 33.8271C23.1235 33.0263 22.4937 32.377 21.7172 32.377Z"
        fill="white"
      />
      <path
        d="M85.4244 35.4388C84.5526 34.5393 83.3931 34.0439 82.1599 34.0439C80.9267 34.0439 79.7672 34.5393 78.8953 35.4388L76.7722 37.629C76.2231 38.1954 76.2231 39.1133 76.7722 39.6796L81.3127 44.3635C81.5764 44.6356 81.9341 44.7883 82.3071 44.7883C82.68 44.7883 83.0377 44.6354 83.3014 44.3635L85.4244 42.1734C87.2244 40.3167 87.2244 37.2957 85.4244 35.4388Z"
        fill="#FF6B81"
      />
      <path
        d="M62.4548 66.6858L55.1354 59.135C54.8718 58.8629 54.514 58.71 54.1411 58.71C53.7681 58.71 53.4104 58.8629 53.1468 59.135C50.5806 61.7821 50.5806 66.0893 53.1468 68.7364C54.3899 70.019 56.0427 70.7253 57.8009 70.7253C59.5589 70.7253 61.2119 70.019 62.455 68.7364C63.004 68.1699 63.004 67.252 62.4548 66.6858Z"
        fill="#FF6B81"
      />
      <path
        d="M69.9117 76.0913C69.6453 76.1555 69.3788 76.187 69.1137 76.187C68.207 76.187 67.3306 75.8192 66.6704 75.1384L64.019 72.4039L46.9431 54.7854C46.088 53.9035 45.742 52.6524 46.0178 51.4383C46.2936 50.2269 47.1395 49.2644 48.2849 48.8651L54.6366 46.6461L61.3966 39.6716C64.0574 36.9275 67.5959 35.4141 71.3583 35.4141C74.4884 35.4154 77.4648 36.4615 79.9055 38.3933C80.3999 38.783 80.872 39.2095 81.32 39.6716C83.9821 42.4172 85.4483 46.0676 85.447 49.9493C85.4483 53.8337 83.9821 57.4843 81.3213 60.2283L74.5598 67.2012L72.4122 73.7532C72.4109 73.7545 72.4109 73.7545 72.4109 73.7545C72.0224 74.9346 71.0877 75.8082 69.9117 76.0913Z"
        fill="#FBDF63"
      />
      <path
        d="M72.4111 73.7545C72.0226 74.9344 71.0879 75.8082 69.9121 76.091C69.6456 76.1552 69.3792 76.1868 69.1141 76.1868C68.2073 76.1868 67.3309 75.819 66.6707 75.1382L64.0444 72.4296C64.702 73.0942 65.5664 73.4523 66.4626 73.4523C66.7277 73.4523 66.9942 73.4207 67.2606 73.3566C68.4366 73.0735 69.3713 72.1999 69.7596 71.02C69.7596 71.02 69.7596 71.02 69.7609 71.0186L71.9087 64.4667L78.6702 57.4937C81.331 54.7496 82.7972 51.0991 82.7959 47.2148C82.7972 43.9839 81.7817 40.9132 79.9058 38.3933C80.4002 38.7829 80.8724 39.2095 81.3203 39.6716C83.9824 42.4171 85.4487 46.0676 85.4474 49.9492C85.4487 53.8336 83.9824 57.4843 81.3216 60.2282L74.5602 67.2011L72.4126 73.7531C72.4111 73.7545 72.4111 73.7545 72.4111 73.7545Z"
        fill="#FFA402"
      />
      <path
        d="M58.7352 30.6228C56.4095 30.6228 54.5176 32.5744 54.5176 34.9734C54.5176 35.7743 55.147 36.4236 55.9238 36.4236C56.7006 36.4236 57.3301 35.7743 57.3301 34.9734C57.3301 34.1737 57.9605 33.5232 58.7354 33.5232C59.512 33.5232 60.1416 32.8739 60.1416 32.073C60.1416 31.2721 59.512 30.6228 58.7352 30.6228Z"
        fill="#FF6B81"
      />
      <path
        d="M58.7353 24.511C53.143 24.511 48.5933 29.2044 48.5933 34.9733C48.5933 35.7742 49.2227 36.4235 49.9995 36.4235C50.7763 36.4235 51.4058 35.7742 51.4058 34.9733C51.4058 30.8037 54.6938 27.4114 58.7355 27.4114C59.5121 27.4114 60.1418 26.7621 60.1418 25.9612C60.1418 25.1603 59.5121 24.511 58.7353 24.511Z"
        fill="#FF6B81"
      />
      <path
        d="M85.8581 67.3042C88.1838 67.3042 90.0757 65.3526 90.0757 62.9536C90.0757 62.1527 89.4463 61.5034 88.6695 61.5034C87.8927 61.5034 87.2632 62.1527 87.2632 62.9536C87.2632 63.7533 86.6328 64.4038 85.8579 64.4038C85.0813 64.4038 84.4517 65.0531 84.4517 65.854C84.4517 66.6549 85.0815 67.3042 85.8581 67.3042Z"
        fill="#FF6B81"
      />
      <path
        d="M94.5939 61.5034C93.8173 61.5034 93.1877 62.1527 93.1877 62.9536C93.1877 67.1232 89.8997 70.5155 85.8579 70.5155C85.0813 70.5155 84.4517 71.1648 84.4517 71.9657C84.4517 72.7666 85.0811 73.4159 85.8579 73.4159C91.4503 73.4159 96 68.7225 96 62.9536C96.0002 62.1527 95.3707 61.5034 94.5939 61.5034Z"
        fill="#FF6B81"
      />
      <path
        d="M32.0068 71.427H38.0336C38.8103 71.427 39.4399 70.7777 39.4399 69.9768C39.4399 69.1759 38.8103 68.5266 38.0336 68.5266H32.0068C31.2302 68.5266 30.6006 69.1759 30.6006 69.9768C30.6006 70.7777 31.23 71.427 32.0068 71.427Z"
        fill="#90ABBD"
      />
      <path
        d="M41.778 75.2942H32.0068C31.2302 75.2942 30.6006 75.9435 30.6006 76.7444C30.6006 77.5453 31.2302 78.1946 32.0068 78.1946H41.778C42.5546 78.1946 43.1843 77.5453 43.1843 76.7444C43.1843 75.9435 42.5546 75.2942 41.778 75.2942Z"
        fill="#90ABBD"
      />
    </g>
    <defs>
      <clipPath id="clip0_13359_5794">
        <rect width="96" height="99" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
